export const SOFTLINE_API_WWS_UMSATZABFRAGE = '/v2/wws/umsatzabfrage/umsatzebeneZeitraumAufgliederung';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_EBENEN = '/v2/wws/umsatzabfrage/ebene';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_BELEGART = '/v2/wws/umsatzabfrage/belegart';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_SUBEBENEN = '/v2/wws/umsatzabfrage/subebenen';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_VKFORG = '/v2/wws/umsatzabfrage/vkforg';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_AUFGLEIDERUNG = '/v2/wws/umsatzabfrage/aufgliederungen';
export const SOFTLINE_API_WWS_UMSATZABFRAGE_UMSATZART = '/v2/wws/umsatzabfrage/umsatzart';
